import { useMutation, useQueryClient } from '@tanstack/react-query';
import { rejectPcmpProposalMarketing } from '../api/pcmpProposals.api';
import type { PcmpMktRejectPayload } from '../types/pcmpProposal.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useRejectPcmpProposal(proposalId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpMktRejectPayload) => rejectPcmpProposalMarketing(proposalId, payload),
    ...pcmpActionCallbacks(queryClient, 'Proposal rejected', onSuccess),
  });
}
